// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Ypk5","title":"Header_title__3dvAv","side":"Header_side__1ri_i"};